import React from 'react';
import { GameIcon } from '../../icons/GameIcon';
import { Espin_Game_Definition_Enum, Espin_Role_Enum, TeamMemberFragment } from '../../../generated/spin-graphql';
import { useAppState } from '../../../client/providers/AppProvider';
import { gql } from '@urql/core';

type Props = {
    teamName: string;
    game: Espin_Game_Definition_Enum;
    gameName: string;
    teamMembers: TeamMemberFragment[];
};

gql`
    fragment TeamCard on espin_team {
        id
        display_name
        game {
            game_definition
            name
        }
        members {
            ...TeamMember
        }
    }

    fragment TeamMember on espin_team_members {
        team_role
        player_profile {
            spin_username
            slug
            id
        }
    }
`;

export const TeamCard: React.FC<Props> = ({ teamName, game, gameName, teamMembers }) => {
    const { user, subtier } = useAppState();
    return (
        <div className="our-team-card">
            <h2 className="team-name">{teamName}</h2>
            <div className="game">
                <GameIcon game={game} gameName={gameName} />
                {gameName}
            </div>
            {teamMembers.length === 0 && <div>No active players</div>}
            {teamMembers.length > 0 && (
                <>
                    <p className="roster-label">ROSTER</p>
                    <div className="roster-list">
                        {teamMembers.map((member) => (
                            <div className="player" key={`team-member-${member.player_profile?.spin_username ?? ''}`}>
                                {user?.role === Espin_Role_Enum.EspinCollegeUser && subtier >= 2 && (
                                    <a href={`/players/${member.player_profile.slug}`}>
                                        {member.player_profile.spin_username}
                                    </a>
                                )}
                                {(user?.role !== Espin_Role_Enum.EspinCollegeUser || subtier < 2) && (
                                    <>{member.player_profile.spin_username}</>
                                )}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};
